import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type VisitActionBarProps = {
   readonly children: ReactNode;
};

const VisitActionBar = (props: VisitActionBarProps): JSX.Element => {
   return (
      <ActionBar id='visit-action-bar' testId='visit'>
         {props.children}
      </ActionBar>
   );
};

enum VisitActionBarOrder {
   EducationalMaterials,
   NextVisit,
   DocumentTemplates,
   ConsentTemplates,
   Print,
   MedicalDevices,
   ElectronicReferral,
   Prescription,
   MedicalLeave,
}

export { VisitActionBar, VisitActionBarOrder };
